<fui-modal [state]="state">
  <fui-modal-window>
    <fui-modal-window-toolbar (closed)="cancel()" [title]="'Venue Sign Up'">
    </fui-modal-window-toolbar>
    @if (url) {
      <fui-modal-window-main>
        <fhm-signup-page-content-content [url]="url" [showClose]="true" (closed)="cancel()"></fhm-signup-page-content-content>
      </fui-modal-window-main>
    }
  </fui-modal-window>
</fui-modal>
